import {
  UPDATE_LANGUAGE,
  LanguageAction,
  LanguageState,
} from './Language.types'

export const LanguageReducer = (
  state: LanguageState,
  action: LanguageAction
): LanguageState => {
  switch (action.type) {
    case UPDATE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      }
    default:
      return state
  }
}
